module.exports = __webpack_public_path__ + "img/fh_code_5.f60cf37f.png";